import { Theme, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import WalletTypeIcon from '../WalletTypeIcon';

interface WalletLogoProps {
  type: string;
}

const WalletLogo = ({ type }: WalletLogoProps) => {
  const theme: Theme = useTheme();
  const { t } = useTranslation(['wallets', 'common']);

  switch (type) {
    case 'credit':
      return (
        <WalletTypeIcon
          size={30}
          type="credit"
          bgcolor={theme.palette.purple[600]}
          aria-label={t('types.credit', { ns: 'wallets' })}
        />
      );
    case 'loan':
      return (
        <WalletTypeIcon
          size={30}
          type="loan"
          bgcolor={theme.palette.teal[500]}
          aria-label={t('types.loan', { ns: 'wallets' })}
        />
      );
    default:
      return (
        <WalletTypeIcon
          size={30}
          type="basic"
          bgcolor={theme.palette.pink[500]}
          aria-label={t('types.basic', { ns: 'wallets' })}
        />
      );
  }
};

export default WalletLogo;

